import { Component, Input } from '@angular/core';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IEquityMovementScheduleFinancialTableData } from '../../../interfaces/pdf-tron/equity-movement-schedule-financial-table-data.interface';

@UntilDestroy()
@Component({
    selector: 'aumico-annualReport-equity-movement-swiss-display-component',
    templateUrl: 'equity-movement-schedule-swiss-display.component.html',
    styleUrls: ['equity-movement-schedule-swiss-display.component.scss'],
})
export class EquityMovementScheduleSwissDisplayComponent {
    readonly maxFlisLengthForBigFontSize = 4;

    @Input() rows: IEquityMovementScheduleFinancialTableData[] = [];

    @Input() columnNames: string[] = [];

    @Input() styleOptions: IStyleOptions | undefined;
}
